import { baseURL } from '../axios/axios';
import { guestHeaders } from '../Service/guest';

export const absoluteUrl = (path) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return baseURL.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
};

/**
 * GET 方式读取 SSE：fetch + reader，按行解析 data: JSON。
 * onEvent(data) 返回 false 时提前结束。返回读取结束原因：'done' | 'stopped'。
 */
export async function streamSse(path, { signal, headers = {}, onEvent } = {}) {
    const response = await fetch(absoluteUrl(path), {
        method: 'GET',
        headers: { Accept: 'text/event-stream', ...guestHeaders(), ...headers },
        signal,
    });
    if (!response.ok || !response.body) {
        let msg = '';
        try {
            const body = await response.json();
            msg = body?.msg;
        } catch {
            // 非 JSON 错误体
        }
        throw new Error(msg || `请求失败（${response.status}）`);
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';
        for (const raw of lines) {
            const line = raw.trim();
            if (!line.startsWith('data:')) continue;
            const payload = line.slice(5).trim();
            if (!payload) continue;
            let data;
            try {
                data = JSON.parse(payload);
            } catch {
                data = { chatToken: payload };
            }
            if (onEvent?.(data) === false) {
                reader.cancel().catch(() => {});
                return 'stopped';
            }
        }
    }
    return 'done';
}

/** 用 fetch 下载文件流，文件名取 content-disposition 的 filename* / filename */
export async function downloadFile(path, fallbackName = '下载文件') {
    const response = await fetch(absoluteUrl(path), { headers: guestHeaders() });
    if (!response.ok) {
        let msg = '';
        try {
            msg = (await response.json())?.msg;
        } catch {
            // 非 JSON 错误体
        }
        throw new Error(msg || '下载失败，请稍后重试');
    }
    const disposition = response.headers.get('content-disposition') || '';
    let name = fallbackName;
    const star = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
    const plain = disposition.match(/filename="?([^";]+)"?/i);
    try {
        if (star) name = decodeURIComponent(star[1].replace(/"/g, ''));
        else if (plain) name = decodeURIComponent(plain[1]);
    } catch {
        // 文件名解码失败时用默认名
    }
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
